import { render, staticRenderFns } from "./DeleteClinicDialog.vue?vue&type=template&id=728b24d9"
import script from "./DeleteClinicDialog.vue?vue&type=script&lang=js"
export * from "./DeleteClinicDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports